import React, { useEffect, useState } from 'react'
import { Cookies } from 'react-cookie';
import useWebSocket from 'react-use-websocket';
import DashboardEquity from '../../../../assets/user/DashboardEquity';
import TotalProfit from '../../../../assets/user/TotalProfit';
import UsedMargin from '../../../../assets/user/UsedMargin';
import FreeMargin from '../../../../assets/user/FreeMargin';
import PNLCard from './PNLCard'
import { GetAccountSummaryApi } from '../../../../api/request/dashboard';
import toast from 'react-hot-toast';
import { use } from 'react';

const Overview = ({ loginId }) => {
    const [liveData, setLiveData] = useState(null);
    const [data, setData] = useState([]);
    const cookies = new Cookies();

    // const { sendJsonMessage, lastJsonMessage } = useWebSocket(`${process.env.REACT_APP_SOCKET_URL}/trading/ws?authorization=Bearer ${cookies.get('token')}`,
    //     { shouldReconnect: () => true, share: true }
    // );

    const getAccountSummary = async () => {
        try {
            const { data } = await GetAccountSummaryApi(loginId);
            setData(data?.data);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
        }
    };

    // useEffect(() => {
    //     sendJsonMessage({ action: "subscribe", eventType: "UserLiveDashboard", loginId });
    //     return () => {
    //         sendJsonMessage({ action: "unsubscribe", eventType: "UserLiveDashboard", loginId });
    //     }
    // }, [loginId])

    // useEffect(() => {
    //     if (lastJsonMessage?.eventType === "UserLiveDashboard") {
    //         setLiveData(lastJsonMessage?.data?.Data);
    //     }
    // }, [lastJsonMessage])

    useEffect(() => {
        getAccountSummary();
    }, [loginId])

    // const statisticsCards = [
    //     { title: 'Equity', value: liveData?.Equity, color: "bg-[#E9E7FD]", icon: <DashboardEquity color="#7367F0" /> },
    //     { title: 'Total Profit', value: liveData?.ProfitLoss, color: 'bg-[#D6F4F8]', icon: <TotalProfit color="#00BAD1" /> },
    //     { title: 'Used Margin', value: liveData?.UsedMargin, color: 'bg-[#FFF0E1]', icon: <UsedMargin color="#FF9F43" /> },
    //     { title: 'Free Margin', value: liveData?.FreeMargin, color: 'bg-[#DDF6E8]', icon: <FreeMargin color="#28C76F" /> },
    // ];

    const statisticsCards = [
        { title: 'Equity', value: data?.equity, color: "bg-[#E9E7FD]", icon: <DashboardEquity color="#7367F0" /> },
        { title: 'Total Profit', value: data?.profitLoss, color: 'bg-[#D6F4F8]', icon: <TotalProfit color="#00BAD1" /> },
        { title: 'Used Margin', value: data?.usedMargin, color: 'bg-[#FFF0E1]', icon: <UsedMargin color="#FF9F43" /> },
        { title: 'Free Margin', value: data?.freeMargin, color: 'bg-[#DDF6E8]', icon: <FreeMargin color="#28C76F" /> },
    ];

    return (
        <div className='border-2 border-light rounded-[10px] p-5 h-full'>
            <div className="flex flex-col gap-5 h-full">
                <h2 className="text-lg font-semibold">Statistics</h2>

                <div className="grid grid-cols-2 xl:grid-cols-4 gap-5">
                    {statisticsCards?.map((card) => (
                        <PNLCard {...card} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Overview